import { InlineSpinner } from "components/base/Spinner";
import { BsTrash } from "react-icons/bs";
import { CiEdit } from "react-icons/ci";
import { FiChevronRight } from "react-icons/fi";
import { HiOutlineDocumentDuplicate } from "react-icons/hi";
import { IoChevronBack, IoChevronForward, IoRefresh } from "react-icons/io5";
import { TbSend2 } from "react-icons/tb";
import { VscSync } from "react-icons/vsc";

export const Button = ({
  className = "",
  children,
  loading,
  next,
  prev,
  edit,
  duplicate,
  trash,
  icon,
  send,
  primary,
  danger,
  refresh,
  sync,
  odoo,
  inline,
  ...rest
}) => {
  return (
    <button
      className={`font-semibold opacity-90 hover:opacity-100 rounded-full disabled:cursor-not-allowed disabled:opacity-50 flex items-center space-x-2 text-left font-sans
          ${
            primary
              ? "px-5 py-2 bg-gradient-to-br from-sky-500 to-purple-500 text-white active:from-sky-600 active:via-sky-600 active:to-fuchsia-600"
              : odoo
                ? "text-purple-600 hover:text-purple-700 active:text-purple-800 dark:text-purple-700 dark:hover:text-purple-800 dark:active:text-purple-900"
                : danger || trash
                  ? "text-red-600 hover:text-red-700 active:text-red-800 dark:text-red-700 dark:hover:text-red-800 dark:active:text-red-900"
                  : "text-sky-600 hover:text-sky-700 active:text-sky-800"
          }
          ${className}
        `}
      {...rest}
      disabled={loading || rest.disabled}
    >
      {loading ? (
        <div>
          <InlineSpinner
            color={primary ? "#eee" : "#00bbd6"}
            size={14}
            text={null}
          />
        </div>
      ) : prev ? (
        <IoChevronBack size={16} />
      ) : icon ? (
        icon
      ) : null}
      {children !== null && children !== undefined ? (
        <div className={inline ? "align-baseline" : ""}>{children}</div>
      ) : null}
      {next ? <IoChevronForward size={16} /> : null}
      {send ? <TbSend2 size={14} /> : null}
      {sync ? <VscSync size={14} /> : null}
      {edit ? <CiEdit size={14} className="-translate-x-1" /> : null}
      {refresh && <IoRefresh size={14} />}
      {duplicate ? (
        <HiOutlineDocumentDuplicate size={14} className="-translate-x-1" />
      ) : null}
      {trash ? <BsTrash size={14} /> : null}
    </button>
  );
};

export const CharlesButtonWithArrow = ({ show, children, ...rest }) => {
  return (
    <Button {...rest}>
      <div className="flex items-center">
        {children !== null && children !== undefined ? (
          <span className="pr-1">{children}</span>
        ) : null}
        <FiChevronRight
          className={`transform-gpu duration-200 inline-block align-middle
            ${show ? "rotate-90" : "rotate-0"}`}
          size={21}
        />
      </div>
    </Button>
  );
};

export default Button;
